import { render, staticRenderFns } from "./end-session-tab.vue?vue&type=template&id=1fa72a3e&"
import script from "./end-session-tab.vue?vue&type=script&lang=js&"
export * from "./end-session-tab.vue?vue&type=script&lang=js&"
import style0 from "./end-session-tab.vue?vue&type=style&index=0&id=1fa72a3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports